import React, { useCallback, useEffect, useState } from "react";
import {
  Modal,
  Button,
  Text,
  Input,
  Dropdown,
  Switch,
  Loading,
} from "@nextui-org/react";
import { makeFetch } from "../../service/makeFetch";
import { useNotifications } from "reapop";
import useStorage from "../storage/useLocalStorage";

export default function DevEdit({
  children,
  makeVisible = false,
  setVisible = () => null,
  info = { role: "Developer" },
  isAdmin = false,
  style = {},
}) {
  const { notify } = useNotifications();
  const [selectedRole, setSelected] = React.useState([
    info?.role === undefined ? "Developer" : info.role?.toString(),
  ]);
  const [newHandle, setNewHandle] = React.useState(info?.name);
  const [isActive, setIsActive] = React.useState(info?.status === "active");
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshAccount = false, setRefreshAccount] =
    useStorage("refreshAccount");

  const selectedRoleValue = React.useMemo(
    () => Array.from(selectedRole).join(", ").replaceAll("_", " "),
    [selectedRole]
  );

  useEffect(() => {
    setSelected([
      info?.role === undefined ? "Developer" : info.role?.toString(),
    ]);
    setNewHandle(info?.name);
    setIsActive(info?.status === "active");
  }, [info]);

  const closeHandler = () => {
    setVisible(false);
    console.log("closed");
  };

  const onHandleChange = useCallback((e) => {
    setNewHandle(e.target.value);
  }, []);

  const onHandleChangeActive = useCallback(
    (e) => {
      setIsActive(!isActive);
    },
    [isActive]
  );

  const updateAccount = useCallback(async () => {
    if (isUpdating === true) return;
    setIsUpdating(true);
    const obj = {
      handle: newHandle,
      roles: [selectedRoleValue.toLowerCase()],
      isActive: isActive,
    };
    const result = await makeFetch({
      url: `account/update`,
      method: "POST",
      privateCall: false,
      body: {
        userId: info.id,
        itemDetailsUpdate: obj,
      },
    });
    setIsUpdating(false);
    if (result === undefined || result === null) {
      notify("Error getting data failed!", "error");
      return;
    }
    if (result?.error === true) {
      notify(result.message, "error");
      return;
    } else {
      notify("User updated!", "success");
      setRefreshAccount(true);
      closeHandler();
    }
    if (typeof window !== "undefined") {
      // setData(result);
    }
  }, [info, selectedRoleValue, newHandle, isActive, isUpdating]);

  return (
    <div style={style}>
      {children}
      <Modal
        closeButton
        blur
        aria-labelledby="modal-title"
        open={makeVisible}
        onClose={closeHandler}
        width="400px"
      >
        <Modal.Header>
          <Text id="modal-title" size={18} b>
            User
          </Text>
        </Modal.Header>
        <Modal.Body>
          {info !== null && makeVisible == true && (
            <>
              <Input
                value={newHandle}
                label="Full Name"
                placeholder={info?.name}
                onChange={onHandleChange}
              />
              {isAdmin === true && (
                <>
                  <Text>Role</Text>
                  <Dropdown>
                    <Dropdown.Button
                      flat
                      color="secondary"
                      css={{ tt: "capitalize" }}
                    >
                      {selectedRoleValue}
                    </Dropdown.Button>
                    <Dropdown.Menu
                      aria-label="Single selection actions"
                      color="secondary"
                      disallowEmptySelection
                      selectionMode="single"
                      selectedKeys={selectedRole}
                      onSelectionChange={setSelected}
                    >
                      <Dropdown.Item key="admin">Admin</Dropdown.Item>
                      <Dropdown.Item key="developer">Developer</Dropdown.Item>
                      <Dropdown.Item key="user">User</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  <Text>Active</Text>
                  <Switch checked={isActive} onChange={onHandleChangeActive} />
                </>
              )}
            </>
          )}
          <Text>Dev Key: {info?.developerKey}</Text>
        </Modal.Body>
        <Modal.Footer>
          <Button auto flat color="error" onPress={closeHandler}>
            Close
          </Button>
          <Button auto onPress={updateAccount}>
            {isUpdating === true ? (
              <Loading size="sm" color={"white"} />
            ) : (
              "Save"
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
